import { atom } from "jotai"

export const errorBoundaryResetVersionAtom = atom(0)
